export default __webpack_public_path__ + "static/SVGBidders-1a8edb6cc2550da4e4a25a670aa66406.svg";